export { WORD_LIST_COLLECTION, PAGE_GROUPS, PAGES } from "./pagesConsts";

export {
	AD_LAYOUTS,
	AD_LAYOUT_STUBS,
	AD_PAGETYPES,
	AD_PLACEMENTS,
	AD_POSITIONS,
	ADITUDE_BASE_IDS,
} from "./adConsts";

export { COUNTRIES } from "./countriesConsts";

export {
	DICTIONARY_LISTS,
	GAME_ICONS_SPRITE_META_SMALLER_ICONS,
	GAME_ICONS_SPRITE_META_SMALL_ICONS,
	GAME_ICONS_SPRITE_META_BIG_ICONS,
	DICTIONARIES_IN_API,
} from "./dictionariesConsts";

export {
	YDR_PROTOCOL,
	WF_PROTOCOL,
	CANONICAL_PROTOCOL,
	YDR_URL,
	API_SERVICE,
	API_SERVICE_AUTH,
	CMS_API,
	SAVEDWORDS_KEYNAME,
	DICTIONARY_KEYNAME,
	DEFAULTWORDS_COOKIENAME,
	VERSION_CHECK_POLL_FREQ,
	VERSION_CHECK_ERROR,
	CANONICAL_HOST,
	NEWSLETTERS,
	GOOGLE_CLIENT_ID,
} from "./networkConsts";

export {
	UNSCRAMBLER_MIN_LENGTH,
	UNSCRAMBLER_MAX_LENGTH,
	UNSCRAMBLER_MAX_WILDCARDS,
	API_MAX_RESULTS,
	ASC,
	DESC,
	GAME_TYPES,
	WORDS,
	SCORES,
	DIGRAPHS,
} from "./searchConsts";

export { TRACKER_DATA, TRACKER_SETTINGS } from "./trackersConsts";

export {
	STICKY_AD_TOP_GAP,
	SMALL_DEVICE_WIDTH_MAX,
	MEDIUM_PORTRAIT_WIDTH_MAX,
	MEDIUM_DEVICE_WIDTH_MAX,
	LARGE_DEVICE_WIDTH_MAX,
	TOUCH_DEVICE_HEADER_HEIGHT,
	DESKTOP_HEADER_HEIGHT,
} from "./windowConsts";

export const TRANSPARENT_PNG =
	"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="; // Transparent PNG

export { TOGGLES } from "./togglerConsts";

export { INTERLINK_TYPE, INTERLINK_SPECIAL_CASE } from "./interlinkingConsts";

export { ZEBRALIST } from "./hybridConsts";

export const STAGE = process.env.STAGE;
